/**
 * Created by rathompson on 5/2/22
 * File: SearchInput
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { Input } from '@panwds/react-ui'
import { SearchIcon } from '@panwds/icons'

const SearchInput = ({ ...props }) => {
  return (
    <Input
      prefix={<SearchIcon size='sm' className='cm-text-gray-300'/>}
      {...props}
    />
  )
}

SearchInput.propTypes = {}
export default SearchInput
